"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AVAILABILITY_TAB = exports.CONFIGURATION_TAB = exports.hubSpotQADomain = exports.hubSpotDomain = exports.wrongHubSpotQADomain = exports.wrongHubSpotDomain = exports.THANKYOU_VIRAL_HUBS_CTA = exports.BOOKING_VIRAL_HUBS_CTA = void 0;
var BOOKING_VIRAL_HUBS_CTA = 'booking-page-signup-visual';
exports.BOOKING_VIRAL_HUBS_CTA = BOOKING_VIRAL_HUBS_CTA;
var THANKYOU_VIRAL_HUBS_CTA = 'thank-you-page-signup-visual';
exports.THANKYOU_VIRAL_HUBS_CTA = THANKYOU_VIRAL_HUBS_CTA;
var wrongHubSpotDomain = 'www.hubspot.com';
exports.wrongHubSpotDomain = wrongHubSpotDomain;
var wrongHubSpotQADomain = 'www.hubspotqa.com';
exports.wrongHubSpotQADomain = wrongHubSpotQADomain;
var hubSpotDomain = 'app.hubspot.com';
exports.hubSpotDomain = hubSpotDomain;
var hubSpotQADomain = 'app.hubspotqa.com';
exports.hubSpotQADomain = hubSpotQADomain;
var CONFIGURATION_TAB = 'configuration';
exports.CONFIGURATION_TAB = CONFIGURATION_TAB;
var AVAILABILITY_TAB = 'availability';
exports.AVAILABILITY_TAB = AVAILABILITY_TAB;